import React from 'react';
import './home.css'
export default function Home() {
    return (
        <><header>
        <div className='headerimg'>  <img src="eclub.png"/><br></br><p className='text'>
            
            Electronics Club
            </p>
            <p className='text2'>Innovation Imagination Application</p>
            </div>  
        </header></>
    )
}